var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.025 15.6829C11.8667 15.6829 11.7083 15.6246 11.5833 15.4996C11.3417 15.2579 11.3417 14.8579 11.5833 14.6163L16.2 9.99961L11.5833 5.38294C11.3417 5.14128 11.3417 4.74128 11.5833 4.49961C11.825 4.25794 12.225 4.25794 12.4667 4.49961L17.525 9.55794C17.7667 9.79961 17.7667 10.1996 17.525 10.4413L12.4667 15.4996C12.3417 15.6246 12.1833 15.6829 12.025 15.6829Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9417 10.625L2.91667 10.625C2.575 10.625 2.29167 10.3417 2.29167 10C2.29167 9.65833 2.575 9.375 2.91667 9.375L16.9417 9.375C17.2833 9.375 17.5667 9.65834 17.5667 10C17.5667 10.3417 17.2833 10.625 16.9417 10.625Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.a061e16c50b9d41da5977fc9d8d63d7d.svg";
export { ForwardRef as ReactComponent };